/**
 * 基础菜单 班级管理
 */
<template>
  <div style="background-color: #F5F5F5">
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学员管理</el-breadcrumb-item>
    </el-breadcrumb>-->

    <!-- 班级详情 -->
    <el-descriptions class="margin-top" title="班级信息" :column="3" border style="background-color: white; padding: 10px; border-radius: 5px; height: 17vh;">
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-date"></i>
          班级名称
        </template>
        {{ classItem.className }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-marketing"></i>
          总体练习情况
        </template>
        {{ classItem.avgScore }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-data-analysis"></i>
          通过率预测
        </template>
        {{ classItem.passNum }}
      </el-descriptions-item>
    </el-descriptions>


    <div style="background-color: white; padding: 10px; border-radius: 5px; margin-top: 15px; height: 74.8vh; overflow-y: auto">
      <div class="el-descriptions__title">学员信息</div>

      <!-- 搜索筛选  accordion -->
      <el-collapse ref="coll" v-model="activeCollapseNames">
        <el-collapse-item name="search">
          <template slot="title">
            <!-- 搜索区域折叠行 -->
            <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; width: 100%;" @click.stop="void 0">
              <div style="display: flex; flex-wrap: nowrap; align-items: center;">
                <el-form ref="queryForm" :inline="true" :model="queryParams" class="user-search">
                  <el-form-item label="搜索："></el-form-item>
                  <el-form-item label="" style="width: 180px;">
                    <el-input size="small" style="width: 100%" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.name" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                  <el-form-item label="" style="width: 180px;">
                    <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.phone" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                  <el-form-item label="" style="width: 180px;">
                    <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.idcard" placeholder="请输入身份证号"></el-input>
                  </el-form-item>
                  <el-form-item label="" style="width: 180px;">
                    <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.account" placeholder="请输入卡号"></el-input>
                  </el-form-item>

                  <el-form-item>
<!--                    <el-button size="small" type="primary" icon="el-icon-arrow-down" @click="toggleCollapse">{{ activeCollapseNames.length ? "收起" : "更多" }}</el-button>-->
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="systemFlag != 1">添加学员</el-button>
                    <el-button size="small" type="primary" icon="el-icon-share" @click="handleSendCard()" v-if="systemFlag != 1">发卡</el-button>
                    <el-button size="small" type="primary" icon="el-icon-upload2" @click="importData()" v-if="systemFlag != 1">导入</el-button>
                    <el-button size="small" type="primary" icon="el-icon-download" @click="handleDownload()">下载</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </template>

          <!-- 这是折叠的内容区域 -->
          <div
            style="display: flex; flex-wrap: wrap;"
          >
            <el-form
              :model="queryParams"
              ref="queryForm2"
              :inline="true"
              label-width="68px"
            >

            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>


      <!--列表-->
      <el-table
        ref="multipleTable"
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%;"
        @selection-change="handleSelectionChange"
        :row-key="(row) => { return row.id }"
      >
        <el-table-column type="selection" width="55" align="center" :reserve-selection="true" />
        <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
        <el-table-column prop="name" label="姓名"/>
        <el-table-column prop="phone" label="手机号码"/>
        <el-table-column prop="idcard" label="身份证号"/>
        <el-table-column prop="wxName" label="绑定微信号"/>
        <el-table-column prop="account" label="卡号"/>
        <el-table-column prop="password" label="密码"/>
        <el-table-column prop="subjectName" label="考试科目" width="350"/>

<!--        <el-table-column prop="lx" label="练习情况"/>-->

        <el-table-column prop="avgScore" label="模拟情况（近五次平均分）" width="80">
          <template slot-scope="scope">
            <el-link type="primary" @click="openAvgScore(scope.row)">
              {{ scope.row.avgScore }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="导入时间"/>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
            >
              <el-button
                size="mini"
                icon="el-icon-edit-outline"
                @click="handleEdit(scope.$index, scope.row)"
              >
              </el-button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDel(scope.$index, scope.row)"
              >
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather" style="position: fixed; bottom: 2vh;"></Pagination>
    </div>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="35%" top="5vh" :close-on-click-modal="false" @click="closeDialog" append-to-body>
      <add-student :key="form.id" :item="form" @sonHandleCallback="sonHandleCallback"></add-student>
    </el-dialog>

    <!-- 模拟情况 -->
    <el-dialog title="模拟练习分数" :visible.sync="scoreShow" width="70%" top="5vh" :close-on-click-modal="false" @click="scoreShow = false" append-to-body>
      <div style="max-height: 70vh; overflow-y: auto;">
        <el-table
          size="small"
          :data="scoreList"
          highlight-current-row
          v-loading="false"
          border
          element-loading-text="拼命加载中"
          style="width: 100%;"
          :row-key="(row) => { return row.id }"
        >
          <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
          <el-table-column prop="paperName" label="试卷名称"/>
          <el-table-column prop="avgScore" label="平均分"/>
          <el-table-column prop="paperNum" label="数量">
            <template slot-scope="scope">
              <el-link type="primary" @click="openPaper(scope.row)">
                <span>{{ scope.row.paperNum }}</span>
              </el-link>
            </template>
          </el-table-column>
        </el-table>
<!--        <div v-for="x in scoreList">
          <el-descriptions class="margin-top" :title="x.paperName" :column="4" border style="background-color: white; padding: 10px; border-radius: 5px; height: 13vh;">
            &lt;!&ndash;        <el-descriptions-item>
                      <template slot="label">
                        <i class="el-icon-date"></i>
                        试卷名称
                      </template>
                      {{ x.paperName }}
                    </el-descriptions-item>&ndash;&gt;
            <el-descriptions-item>
              <template slot="label">
                总分
              </template>
              {{ x.totalScore }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                及格分
              </template>
              {{ x.passScore }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                本次得分
              </template>
              {{ x.realScore }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                创建时间
              </template>
              {{ x.createTime }}
            </el-descriptions-item>
          </el-descriptions>
        </div>-->
      </div>
    </el-dialog>

    <!-- 全部模拟情况 -->
    <el-dialog title="全部模拟情况" :visible.sync="paperShow" width="70%" top="5vh" :close-on-click-modal="false" @click="paperShow = false" append-to-body>
      <div style="max-height: 70vh; overflow-y: auto;">

        <el-table
          size="small"
          :data="paperList"
          highlight-current-row
          v-loading="false"
          border
          element-loading-text="拼命加载中"
          style="width: 100%;"
        >
          <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
          <el-table-column prop="paperName" label="试卷名称"/>
          <el-table-column prop="realScore" label="得分"/>
          <el-table-column prop="startTime" label="考试开始时间"/>
          <el-table-column prop="endTime" label="考试结束时间"/>
          <el-table-column prop="useDuration" label="考试用时"/>
        </el-table>

      </div>
    </el-dialog>

    <!-- 学员导入对话框 -->
    <el-dialog :close-on-click-modal="false" :title="upload.title" :visible.sync="upload.open" width="400px" top="6vh"
               append-to-body>
      <el-upload
        ref="upload"
        :limit="1"
        :accept="importFlag == 0 ? '.xlsx, .xls' : '.zip'"
        :action="upload.url"
        :disabled="upload.isUploading"
        :data="upload.data"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"nage zh
        :on-error="handleFileError"
        :on-exceed="handleChang"
        :auto-upload="false"
        drag
      >
        <!--        :on-exceed	="handleExceed"-->

        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip" v-show="importFlag == 0">
<!--          <el-checkbox v-model="upload.updateSupport"/>
          是否更新已经存在的数据-->
          <el-link type="info" style="font-size:16px;color: #409EFF" @click="importTemplate">下载模板</el-link>
        </div>
        <div class="el-upload__tip" style="color:red" slot="tip" v-show="importFlag == 0">提示：仅允许导入“xls”或“xlsx”格式文件！</div>
        <div class="el-upload__tip" style="color:red" slot="tip" v-show="importFlag != 0">提示：仅允许导入“zip”格式文件！</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 导出页面 -->
    <div v-show="exportShow">
      <div id="menu" class="menu">
        <div class="menu-item" @click="exportData(0)">学历证明</div>
        <div class="menu-item" @click="exportData(1)">学员头像</div>
        <div class="menu-item" @click="exportData(2)">身份证</div>
        <div class="menu-item" @click="exportData(3)">花名册</div>
      </div>
    </div>


  </div>
</template>

<script>
import {
  queryStudentList,
  saveStudent,
  updateStudent,
  deleteStudentById,
  queryStudentDetail,
  changeClass,    // 换班
  cancelStu,      // 作废

  // 导入 导出接口
  downloadStudentTemplate,
  importStudent,                  // 导入学员花名册
  importStudentImgByType,         // 导入学员图片
  educationCertificateZip,
  idCardImgZip,
  photoZip,
  exportStudent,                  // 导出花名册
  exportStudentImgByType,         // 导出图片
  approve, queryTestListById, sendCard, downloadTemp, uploadStudent, queryPaper, dcStudentByClassId

} from '../../../api/student'
import {
  queryStudentByClassId,
  queryClassDetail,
  changeClassList, deleteClass, queryClassHeadInfo
} from '../../../api/classInfo'
import { timestampToTime } from '../../../utils/util'
import Pagination from '../../../components/Pagination'
import Template from "../../../components/template";

import AddStudent from "./addStudent"
import {getLearnPlatformList, getMarketingChannelList, updateOrg} from "../../../api/userMG";

export default {
  data() {
    return {
      systemFlag: JSON.parse(localStorage.getItem('userdata')).systemFlag,
      // 模拟情况
      scoreShow: false,
      scoreList: '',

      paperShow: false,
      paperList: [],

      classItem: '',    // 班级数据

      ids: [],    // 多选框ids
      dateValue: [],
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      // rules表单验证
      queryParams: {
        page: 1,
        size: 10,
        name: '',
        phone: '',
        idcard: '',
        account: '',
        bjbId: ''
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      // 查询折叠
      activeCollapseNames: [],

      // 用户导入参数
      importFlag: 0,
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 附加参数
        data: {bjId: ''},
        // 上传的地址
        url: '/api/class/upload'
      },
      fileFlag: '',

      // 导出 弹框
      exportShow: false,

    }
  },
  // 注册组件
  components: {
    Template,
    Pagination,
    AddStudent,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    if (this.$route.query.bjbId) {
      this.queryParams.bjbId = this.$route.query.bjbId;
      this.findClassDetail()
    }
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    updateOrg,
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    titleFocus() {
      this.collClick = this.$refs.coll.setActiveNames
      this.$refs.coll.setActiveNames = () => {}
    },
    titleBlur() {
      this.$refs.coll.setActiveNames = this.collClick
    },
    // 查询折叠
    toggleCollapse() {
      this.activeCollapseNames = this.activeCollapseNames.length ? [] : ["search"];
    },

    // 查询 班级详情
    findClassDetail() {
      queryClassHeadInfo(this.queryParams.bjbId).then(res => {
        if(res.code == 200) {
          this.classItem = res.data;
          if (this.classItem && this.classItem.className) {
            document.title = this.classItem.className;
          }
        }
      })
    },
    // 获取学员数据
    getdata() {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryStudentByClassId(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
          this.pageparm.pageSize = 10;
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.queryParams.page = 1;
      this.getdata()
    },
    // 多选框选中数据
    handleSelectionChange(val) {
      this.ids = val;
    },

    // 打开模拟情况 弹窗
    openAvgScore(item) {
      queryTestListById(item.id).then(res => {
        if (res.code == 200) {
          this.scoreList = res.data;
          this.scoreShow = true;
        }
      })
    },

    openPaper(item) {
      queryPaper(JSON.stringify({userId: item.userId, paperName: item.paperName})).then(res => {
        if (res.code == 200) {
          this.paperList = res.data;
          this.paperShow = true;
        }
      })
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.form = row;
      } else {
        this.title = '添加'
        this.form = {};
      }
    },
    // 编辑、增加页面保存方法
    submitForm() {
      if (this.form.id != undefined && this.form.id != '') {
        var params = {
          id: this.form.id,
          name: this.form.name,
          phone: this.form.phone,
          idcard: this.form.idcard,
          bjbId: this.form.bjbId
        }
        updateStudent(params).then(res => {
          console.log('res  ', res);
          this.editFormShow = false
          this.loading = false
          if (res.code == 200) {
            this.search()
            this.$message({
              type: 'success',
              message: '修改成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          console.log('err  ', err.response);
          this.loading = false
          if (err.response != undefined) {
            this.$message.error('修改失败，请稍后再试！')
          }
        })
      } else {
        this.form.bjbId = this.queryParams.bjbId;
        saveStudent(this.form).then(res => {
          this.editFormShow = false
          this.loading = false
          if (res.code == 200) {
            this.search()
            this.$message({
              type: 'success',
              message: '保存成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.response.data.msg)
        })
      }

    },

    // 发卡
    handleSendCard() {
      if (this.ids.length == 0) {
        this.$message.error('请选择需要发卡的学员');
        return;
      }
      var ids = []
      this.ids.forEach(x => {
        ids.push(x.id)
      })

      sendCard({bjId: this.queryParams.bjbId, studentId: ids.join(',')}).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '发卡成功!'
          })
          this.getdata()
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err.response.data.msg)
      })
    },

    handleDel(index, row) {
      this.$confirm('确定要删除该条数据吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteStudentById({id: row.id, bjbId: this.queryParams.bjbId}).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error(err.response.data.msg)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    sonHandleCallback(data) {
      if (data.type == 'back') {
        this.editFormShow = false
      } else if (data.type == 'saveForm') {
        this.form = data.item;
        this.submitForm();
      }
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    },

    /*
    *  导入
    * */
    importData(x) {
      this.upload.title = '学员导入'
      this.upload.data.bjId = this.queryParams.bjbId
      this.upload.open = true;
    },
    /** 下载模板操作 */
    importTemplate() {
      downloadTemp().then(res => {
        const blob = new Blob([res], { type: 'application/octet-stream' });
        // 创建a标签进行下载
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = "学员导入模板.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {

      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();

      this.getdata();
      this.$message({
        type: 'success',
        dangerouslyUseHTMLString: true,
        message: response
      });

      // this.upload.open = false;
      /*this.upload.isUploading = false;
      this.fileFlag = file.raw;*/
    },
    // 上传失败回调
    handleFileError(err, file, fileList) {
      this.$message.error(JSON.parse(err.message).msg);
    },
    handleChang(file, fileList) {
      this.$message.error('请删除后在添加文件！')
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
      return;

      /*var formData = new FormData();
      formData.append('file', this.fileFlag);
      formData.append('bjId', this.queryParams.bjbId);
      uploadStudent(formData).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '导入成功!'
          })
          this.upload.open = false;
          this.$refs.upload.clearFiles();
          this.search()
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })*/
    },

    // 格式化日期函数
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    /*
    *  导出
    * */
    handleExport(MouseEvent) {
      console.log('MouseEvent', MouseEvent);
      this.exportShow = false;
      this.exportShow = true;
      var menu = document.querySelector('#menu');
      menu.style.left = MouseEvent.clientX + 20 + 'px';
      menu.style.top = MouseEvent.clientY + 5 + 'px';
      document.addEventListener('click', this.foo);

      // this.exportShow = true;
    },
    foo() {
      this.exportShow = false;
      document.removeEventListener('click', this.foo);
    },

    exportData(x) {
      if (x == 0 || x == 11 || x == 12) {
        const currentDate = new Date();
        var title = '';
        var params = {
          /*startTime: this.dateValue.length > 0 ? timestampToTime(this.dateValue[0]).split(' ')[0] : this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)),
          endTime: this.dateValue.length > 0 ? timestampToTime(this.dateValue[1]).split(' ')[0] : this.formatDate(currentDate)*/
          name: this.queryParams.name,
          learnPlatformSeqId: this.queryParams.learnPlatformSeqId,
          marSeqId: this.queryParams.marSeqId,
          approveStatus: this.queryParams.approveStatus,
          payFeeStatus: this.queryParams.payFeeStatus,
          phone: this.queryParams.phone
        }
        params.bjbId = this.queryParams.bjbId

        if(x == 0) {
          params.studentExportEnum = 'ROSTER';
          title = "花名册.xlsx";
        } else if (x == 11) {
          params.studentExportEnum = 'AM_PHE_TONE';
          title = "安培通导出.xlsx";
        } else if (x == 12) {
          params.studentExportEnum = 'EXAMINATION_SYSTEM';
          title = "考试系统导出.xlsx";
        }

        // 花名册
        exportStudent(JSON.stringify(params)).then(res => {
          const blob = new Blob([res], { type: 'application/octet-stream' });
          // 创建a标签进行下载
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = title;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
      } else {
        var title = '';
        var params = {
          name: this.queryParams.name,
          learnPlatformSeqId: this.queryParams.learnPlatformSeqId,
          marSeqId: this.queryParams.marSeqId,
          approveStatus: this.queryParams.approveStatus,
          payFeeStatus: this.queryParams.payFeeStatus,
          phone: this.queryParams.phone
        }
        params.bjbId = this.queryParams.bjbId;
        if (x == 1) {
          title = '头像.zip';
          params.exportType = 'PHOTO';
        } else if (x == 2) {
          title = '身份证正面.zip';
          params.exportType = 'ID_CARD_FRONT';
        } else if (x == 3) {
          title = '身份证反面.zip';
          params.exportType = 'ID_CARD_BACK';
        } else if (x == 4) {
          title = '学历证明.zip';
          params.exportType = 'EDUCATION_CERTIFICATE';
        } else if (x == 5) {
          title = '营业执照.zip';
          params.exportType = 'BUSINESS_LICENSE';
        }

        exportStudentImgByType(JSON.stringify(params)).then(res => {
          const blob = new Blob([res], { type: 'application/octet-stream' });
          // 创建a标签进行下载
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = title;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })

      }
    },

    // 下载 按钮操作
    handleDownload() {
      var params = {
        name: this.queryParams.name,
        phone: this.queryParams.phone,
        idcard: this.queryParams.idcard,
        account: this.queryParams.account,
      }
      params.bjbId = this.queryParams.bjbId;

      dcStudentByClassId(params).then(res => {
        const blob = new Blob([res], { type: 'application/octet-stream' });
        // 创建a标签进行下载
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = '学员信息.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
    }


  }
}
</script>

<style scoped>
.user-search {
  margin-top: 10px;
}
.userRole {
  width: 100%;
}
.btnCss {
  margin-top: 10px;
  margin-left: 0px !important;
}

/* 导出 */
.menu-item {
  display: block;
  line-height: 20px;
  text-align: center;
  margin-top: 2px;
}
.menu-item:hover{
  background-color: #66b1ff;
  color: white;
  cursor:pointer;
}
.menu {
  /*height: 35px;*/
  width: 90px;
  position: absolute;
  border: 1px solid #999;
  border-radius: 10px;
  background-color: #f4f4f4;
  padding: 5px 0px;
}

.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 10px;
}
.el-icon-arrow-down {
  font-size: 12px;
}

/deep/ .el-drawer {
  background-color: #F5F5F5 !important;
  padding: 15px !important;
}

/deep/ .el-collapse {
  margin-top: 10px !important;
  border-top: 0px solid #EBEEF5 !important;
  border-bottom: 0px solid #EBEEF5 !important;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0px;
}

/deep/ .el-collapse-item__arrow{
  display: none;
}

</style>





// WEBPACK FOOTER //
// src/views/goods/student/student.vue